import React from "react";
const BackSVG = ({ color = "black", className, onClick, ...props }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        id="Vector"
        d="M15.541 0C6.967 0 0 6.968 0 15.543C0 24.117 6.967 31.086 15.541 31.086C24.115 31.086 31.082 24.118 31.082 15.543C31.082 6.968 24.115 0 15.541 0ZM15.541 1.197C23.446 1.197 29.887 7.637 29.887 15.543C29.887 23.449 23.446 29.889 15.541 29.889C7.636 29.889 1.195 23.449 1.195 15.543C1.195 7.637 7.636 1.197 15.541 1.197ZM14.164 8.852C14.009 8.852 13.86 8.908 13.742 9.026L7.648 15.12C7.535 15.233 7.472 15.384 7.472 15.542C7.472 15.7 7.534 15.852 7.648 15.966L13.744 22.062C13.982 22.297 14.349 22.299 14.586 22.062C14.824 21.824 14.824 21.454 14.586 21.216L9.514 16.144L22.94 16.142C23.276 16.142 23.538 15.88 23.538 15.544C23.538 15.208 23.276 14.946 22.94 14.946H9.514L14.588 9.874C14.826 9.636 14.826 9.266 14.588 9.028C14.47 8.91 14.317 8.852 14.164 8.852Z"
        fill={color}
      />
    </svg>
  );
};

export default BackSVG;
